import React, { useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import { Form, Input, Button, Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'

interface IProps {
  onQuery?: (value: any) => void,
  loading?: boolean;
  initialValue?: any
}

const QueryForm = ({ onQuery, initialValue, loading }: IProps, ref: any) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const initialInfo = useRef<IProps['initialValue']>();

  const onFinish = (values: any) => {
    if (typeof onQuery === 'function') {
      onQuery(values)
    }
  }

  const onReset = () => {
    form.resetFields()
    if (initialInfo.current) {
      form.setFieldsValue(initialInfo.current);
      initialInfo.current = undefined;
    }
    if (typeof onQuery === 'function') {
      onQuery({...form.getFieldsValue()})
    }
  }

  useImperativeHandle(ref, () => ({
    resetQuery: onReset,
    submitQuery: () => form.submit(),
  }))

  useEffect(()=>{
    initialInfo.current = initialValue;
  },[initialValue?.name])

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label="MedDRA code" name="code">
            <Input placeholder={t('ikg.input',{name:'MedDRA code'})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.lowLevelLang')} name="name">
            <Input placeholder={t('ikg.input',{name:t('dict.lowLevelLang')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.lltCurrency')} name="lltCurrency">
            <Input placeholder={t('ikg.input',{name:t('dict.lltCurrency')})} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <Button onClick={onReset}>{t('ikg.reset')}</Button>
            <Button type="primary" onClick={() => form.submit()} ghost loading={loading}>
              {t('ikg.query')}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default forwardRef(QueryForm)
